// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__SHWWS","ActiveNavigationItem":"NavigationItem_ActiveNavigationItem__xfFGC"};